import { useContext, useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useScreenWidth from "../../../../hooks/useScreenWidth";
import { AuthContext } from "../../../../contexts/AuthContext";
import { Loader } from "../../../../components";
import { postRequest } from "../../../../constants/api";
import { Container, Card, Form, Row, Col } from "react-bootstrap";
import {
  Box,
  Alert,
  Button,
  Snackbar,
  Typography,
  Autocomplete,
  TextField,
} from "@mui/material";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SaveIcon from "@mui/icons-material/Save";

const UbahJual = () => {
  const screenSize = useScreenWidth();
  const { user, dispatch, setting } = useContext(AuthContext);
  const [open, setOpen] = useState(false);
  const [validated, setValidated] = useState(false);
  const [noNotaJual, setNoNotaJual] = useState("");
  const [jenisJual, setJenisJual] = useState("");
  const [inputTanggalJual, setInputTanggalJual] = useState(new Date());
  const [kodePelanggan, setKodePelanggan] = useState("");
  const [kodeCOA, setKodeCOA] = useState("");

  const [pelanggans, setPelanggans] = useState([]);
  const [coas, setCoas] = useState([]);
  const [error, setError] = useState(false);
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const jenisJualOption = ["TUNAI", "HUTANG"];
  let pelangganOptions = pelanggans.map((pelanggan) => ({
    label: `${pelanggan.kodePelanggan} - ${pelanggan.namaPelanggan}`,
  }));
  let coaOptions = coas.map((coa) => ({
    label: `${coa.kodeCOA} - ${coa.namaCOA}`,
  }));

  useEffect(() => {
    getPelanggansData();
    getCoasData();
    getJualById();
  }, []);

  const getJualById = async () => {
    setLoading(true);
    const response = await postRequest(`/juals/${id}`, {}, navigate, dispatch);
    setNoNotaJual(response.data.noNotaJual);
    setJenisJual(response.data.jenisJual);
    setInputTanggalJual(new Date(response.data.tanggalJual));
    setKodePelanggan(
      `${response.data.pelanggan.kodePelanggan} - ${response.data.pelanggan.namaPelanggan}`
    );
    if (response.data.coa) {
      setKodeCOA(`${response.data.coa.kodeCOA} - ${response.data.coa.namaCOA}`);
    }
    setLoading(false);
  };

  const getPelanggansData = async () => {
    const response = await postRequest(`/pelanggans`, {}, navigate, dispatch);
    setPelanggans(response.data);
  };

  const getCoasData = async () => {
    const response = await postRequest(`/COAsKasBank`, {}, navigate, dispatch);
    setCoas(response.data);
  };

  const updateJual = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    const form = e.currentTarget;

    let tempCheckValidity =
      form.checkValidity() &&
      jenisJual.length !== 0 &&
      kodePelanggan.length !== 0;
    if (jenisJual === "TUNAI") {
      tempCheckValidity =
        form.checkValidity() &&
        jenisJual.length !== 0 &&
        kodePelanggan.length !== 0 &&
        kodeCOA.length !== 0;
    }

    if (tempCheckValidity) {
      setLoading(true);
      try {
        setLoading(true);
        await postRequest(
          `/updateJual/${id}`,
          {
            tanggalJual: inputTanggalJual,
            jenisJual,
            kodePelanggan: kodePelanggan.split(" -", 1)[0],
            kodeCOA: kodeCOA.split(" -", 1)[0],
          },
          navigate,
          dispatch
        );
        setLoading(false);
        navigate(`/daftarJual/jual/${id}`);
      } catch (error) {
        alert(error);
      }
      setLoading(false);
    } else {
      setError(true);
      setOpen(!open);
    }
    setValidated(true);
  };

  if (loading) {
    return <Loader />;
  }

  const textRight = {
    textAlign: screenSize >= 650 && "right",
  };

  return (
    <Container>
      <h3>Transaksi</h3>
      <h5 style={{ fontWeight: 400 }}>Ubah Jual</h5>
      <hr />
      <Card>
        <Card.Header>Jual</Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={updateJual}>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    No. Nota :
                  </Form.Label>
                  <Col sm="8">
                    <Form.Control
                      required
                      value={noNotaJual}
                      disabled
                      readOnly
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Jenis Jual <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={jenisJualOption}
                      renderInput={(params) => (
                        <TextField
                          error={error && jenisJual.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onInputChange={(e, value) => {
                        setJenisJual(value);

                        if (value !== "TUNAI") {
                          setKodeCOA("");
                        }
                      }}
                      value={jenisJual}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Tgl. Jual <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <DatePicker
                      required
                      dateFormat="dd/MM/yyyy"
                      selected={inputTanggalJual}
                      customInput={<Form.Control required />}
                      onChange={(date) => setInputTanggalJual(date)}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Pelanggan <b style={colorRed}>*</b> :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={pelangganOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodePelanggan.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onInputChange={(e, value) => {
                        setKodePelanggan(value);
                      }}
                      value={kodePelanggan}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <Form.Group
                  as={Row}
                  className="mb-3"
                  controlId="formPlaintextPassword"
                >
                  <Form.Label column sm="4" style={textRight}>
                    Kode Kas{" "}
                    {jenisJual === "TUNAI" && <b style={colorRed}>*</b>} :
                  </Form.Label>
                  <Col sm="8">
                    <Autocomplete
                      size="small"
                      disablePortal
                      id="combo-box-demo"
                      options={coaOptions}
                      renderInput={(params) => (
                        <TextField
                          error={error && kodeCOA.length === 0 && true}
                          size="small"
                          {...params}
                        />
                      )}
                      onChange={(e, value) => {
                        if (value) {
                          setKodeCOA(value.label);
                        } else {
                          setKodeCOA("");
                        }
                      }}
                      value={kodeCOA}
                      disabled={jenisJual !== "TUNAI" && true}
                    />
                  </Col>
                </Form.Group>
              </Col>
            </Row>
            <Box sx={spacingTop}>
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => navigate(`/daftarJual/jual/${id}`)}
                sx={{ marginRight: 2 }}
              >
                {"< Kembali"}
              </Button>
              <Button
                variant="contained"
                startIcon={<SaveIcon />}
                type="submit"
              >
                Simpan
              </Button>
            </Box>
          </Form>
        </Card.Body>
      </Card>
      {error && (
        <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
          <Alert onClose={handleClose} severity="error" sx={alertBox}>
            Data belum terisi semua!
          </Alert>
        </Snackbar>
      )}
    </Container>
  );
};

export default UbahJual;

const spacingTop = {
  mt: 4,
};

const alertBox = {
  width: "100%",
};

const subTitleText = {
  fontWeight: "900",
};

const colorRed = {
  color: "red",
};
